import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isPc: document.documentElement.clientWidth > 750 ? true : false,
    allowScroll: true,
    cache: {
      newsList: [],
      wonderfulVideoList: [],
      partnerList: [],
      seminarList: false,
      agendaFilterData: false,
      seminarInfo: false,
      wonderfulPic: false,
      wonderfulWords: false,
      guestList: false,
      extHallList: false,
      extHallChildList: [],
      fileList: [],
      folderMap: {},
      specialFiles: false,
      allAgenda: [],
      agendaAddress: [],
      liveCate: false,
      agendaAddressFilter: false,
      specialAddressDict: false,
      firstMainLiveAgenda: false,
      secondMainLiveAgenda: false,
    },
    showControl: {
      showNavAgendaDesc: true,
      showNavAgendaList: true,
      showNavHall: true,
      showNavNews: true,
      showNavPartner: true,
      showNavVideo: true,
      showNavGuest: true,
      showNavPic: false,
      showNavWords: true,
      showNavDownload: false,
      showIconCollect: true,
      showIconLive: false,
      showIconPreview: false,
      showIconDownload: false,
      showNoFile: false,
    },
    myData: {
      isRequest: false,
      checkInStatus: '',
      username: '',
      email: '',
      downloadEmail: '',
      phone: '',
      lingkaren: '',
      lingkarenshoujihao: '',
      myOrderAgendaList: [],
      myOrderHallList: [],
    },
    trigger: {
      agendaLike: 0,
      agendaReg: 0,
    },
    orderOnline: 9,
    orderOffline: 9,
    isOffline: false,
    isOnline: false,
    orderStop: true,
    // 报名使用
    isLogin: false,
    // 官网登录态使用
    userLogin: false,
    relationId: '',
    isStudent: false,
    silentFail: false,
    showGlobalToast: false,
    showGlobalToastMsg: '',
    showGlobalToastTime: 0,
    agendaStatus: '',
    liveStatus: '',
    wapNavIsShow: false,
    wapGuessLikeShow: false,
    showCollectionSuccessToast: false,
    showCollectionCancelToast: false,
  },
  mutations: {
    setMainLiveAgendaCache(state, data){
      if(data.i_meetingLiveType[0] == '05.17'){
        state.cache.firstMainLiveAgenda = data;
        // console.log('setMainLiveAgendaCache 05.17', data.name, state.cache.firstMainLiveAgenda);
      }else if(data.i_meetingLiveType[0] == '05.18'){
        state.cache.secondMainLiveAgenda = data;
        // console.log('setMainLiveAgendaCache 05.18', data.name, state.cache.secondMainLiveAgenda);
      }
      
    },
    setOrderStop(state, data) {
      state.orderStop = data;
    },
    showCollectionSuccessToast(state, data){
      state.showCollectionSuccessToast = data;
      state.showCollectionCancelToast = false;
    },
    showCollectionCancelToast(state, data){
      state.showCollectionCancelToast = data;
      state.showCollectionSuccessToast = data;
    },
    setWapGuessLikeShow(state, data) {
      state.wapGuessLikeShow = data;
    },
    setAgendaLikeTrigger(state) {
      state.trigger.agendaLike = state.trigger.agendaLike + 1;
    },
    setAgendaRegTrigger(state) {
      state.trigger.agendaReg = state.trigger.agendaReg + 1;
    },
    setUserData(state, data) {
      state.myData.checkInStatus = data.checkInStatus;
      state.myData.username = data.username;
      state.myData.email = data.email;
      state.myData.downloadEmail = data.email;
      state.myData.phone = data.phone;
      state.myData.lingkaren = data.lingkaren;
      state.myData.lingkarenshoujihao = data.lingkarenshoujihao;
    },
    setLiveCateCache(state, data) {
      state.cache.liveCate = data;
    },
    setSpecialAddressDictCache(state, data) {
      state.cache.specialAddressDict = data;
    },
    setAgendaAddressFilterCache(state, data) {
      state.cache.agendaAddressFilter = data;
    },
    setAgendaAddressCache(state, data) {
      state.cache.agendaAddress = data;
    },
    setWapNavIsShow(state, data) {
      state.wapNavIsShow = data;
    },
    setIsOnline(state, data) {
      state.isOnline = data;
    },
    setIsOffline(state, data) {
      state.isOffline = data;
    },
    setLiveStatus(state, data) {
      state.liveStatus = data;
      if(data=='middle' || data=='after'){
        state.showControl.showIconLive = true;
      }
    },
    setAgendaStatus(state, data) {
      state.agendaStatus = data;
    },
    setDownloadEmail(state, data) {
      state.myData.downloadEmail = data;
    },
    setShowNoFile(state, data) {
      state.showControl.showNoFile = data;
    },
    setAllAgendaCache(state, data) {
      state.cache.allAgenda = data;
    },
    setFolderMapCache(state, data) {
      state.cache.folderMap[data.key] = data.value;
    },
    setSpecialFilesCache(state, data) {
      state.cache.specialFiles = data;
    },
    setMyOrderAgendaList(state, data) {
      state.myData.myOrderAgendaList = data;
    },
    setMyOrderHallList(state, data) {
      state.myData.myOrderHallList = data;
    },
    showGlobalToast(state, obj) {
      state.showGlobalToast = obj.status;
      state.showGlobalToastTime = obj.time;
      state.showGlobalToastMsg = obj.msg;
    },
    setShowGlobalToast(state, data) {
      state.showGlobalToast = data;
    },
    setShowGlobalToastTime(state, data) {
      state.showGlobalToastTime = data;
    },
    setShowGlobalToastMsg(state, data) {
      state.showGlobalToastMsg = data;
    },
    setSilentFail(state, data) {
      state.silentFail = data;
    },
    setRelationId(state, data) {
      let id = '';
      switch(data){
        // case '其他':
        //   id = 9;
        //   break;
        case '学生':
          id = 7;
          break;
        // case '老师':
        //   id = 10;
        //   break;
        // case '联盟协会':
        //   id = 6;
        //   break;
        case '分析师':
          id = 3;
          break;
        case '媒体':
          id = 4;
          break;
        case '华为员工':
          id = 8;
          break;
        case '客户':
          id = 2;
          break;
        case '生态伙伴/渠道':
          id = 1;
          break;
        default:
          id = '';
      }
      state.relationId = id;
      if(id == 7 && state.orderOnline == 1){
        state.isStudent = true;
      }
    },
    setIsLogin(state, data) {
      state.isLogin = data;
    },
    setUserLogin(state, data) {
      state.userLogin = data;
    },
    setAllowScroll(state, data) {
      state.allowScroll = data;
    },
    setNewsListCache(state, data) {
      state.cache.newsList = data;
      if(data){
        state.showNavNews = true;
      }
    },
    setWonderfulVideoListCache(state, data) {
      state.cache.wonderfulVideoList = data;
    },
    setWonderfulPicCache(state, data) {
      state.cache.wonderfulPic = data;
    },
    setWonderfulWordsCache(state, data) {
      state.cache.wonderfulWords = data;
    },
    setPartnerListCache(state, data) {
      state.cache.partnerList = data;
    },
    setSeminarListCache(state, data) {
      state.cache.seminarList = data;
    },
    setPartnerChildListCache(state, data) {
      state.cache.partnerList.map(item=>{
        if(item.categoryId == data.id){
          item.list = data.list;
        }
      })
    },
    setAgendaFilterDataCache(state, data) {
      state.cache.agendaFilterData = data;
    },
    setSeminarInfoCache(state, data) {
      state.cache.seminarInfo = data;
    },
    setGuestListCache(state, data) {
      state.cache.guestList = data;
    },
    setExtHallListCache(state, data) {
      state.cache.extHallList = data;
    },
    setExtHallChildListCache(state, data) {
      state.cache.extHallChildList.push(data);
    },
    setExtHallChildDetailCache(state, data) {
      state.cache.extHallChildList.map(item=>{
        if(item.id == data.content.id){
          item.content = data.content.content2;
          item.banner = data.content.showImagesUrl;
        }
      });
    },
    setFileListCache(state, data) {
      state.cache.fileList.push(data);
    },
    setShowNavAgendaDesc(state, data) {
      state.showNavAgendaDesc = data;
    },
    setShowNavHall(state, data) {
      state.showNavHall = data;
    },
    setOrderOnline(state, data) {
      state.orderOnline = data;
    },
    setOrderOffline(state, data) {
      state.orderOffline = data;
    },
    setGetUserStatusRequest(state, data) {
      state.myData.isRequest = data;
    },
  },
  actions: {
  }
});
